import Immutable from 'immutable'
import * as USER_ACTION from '../constants/types/userTypes'
import * as ACTION from '../constants/types/dashboardTypes';
import { stateStructure } from './_stateStructure.js'

const initialState = Immutable.fromJS( stateStructure.dashboard );

export default function game(state = initialState, action) {

	let _state = state.toJS();

	switch (action.type) {
		// 获取真人电子投注记录 falls through
		case ACTION.GET_BET_RECORD_FOR_CASINO:
		// 获取银行卡信息 falls through
		case ACTION.GET_BANK_INFO:
		// 绑定银行卡信息 falls through
		case ACTION.ADD_BANK_CARD:
		// 绑定银行卡信息 falls through
		case ACTION.REBIND_BANK_CARD:
		// 获取转账信息 falls through
		case ACTION.GET_TRANSFER_RECORD:
		// 追号记录 falls through
		case ACTION.GET_TRACKS:
		// 彩票账变 falls through
		case ACTION.GET_LOTTERY_CR:
		// 彩票报表 falls through
		case ACTION.GET_LOTTERY_REPORT:
		// 日亏损 falls through
		case ACTION.GET_DAILY_LOSS:
		// 月亏损 falls through
		case ACTION.GET_MONTH_LOSS:
		// 真人电子娱乐 falls through
		case ACTION.GET_EPROFITLOSS:
		// 体育反水 falls through
		case ACTION.GET_SPORT_COMPACT:
		// kgame反水 falls through
		case ACTION.GET_KGAME_COMPACT:
		// 电竞反水 falls through
		case ACTION.GET_ESPORTS_COMPACT:
		// 真人反水 falls through
		case ACTION.GET_CASINO_COMPACT:
		// 棋牌返水 falls through
		case ACTION.GET_PORKER_COMPACT:	
		// 幸运棋牌反水 falls through
		case ACTION.GET_CHESS_COMPACT:
		// 下级日工资 falls through
		case ACTION.GET_TEAM_WAGE:
		// 日工资 falls through
		case ACTION.GET_DAILY_WAGES:
		// 投注记录 falls through
		case ACTION.GET_BET_RECORD:
		// 获取账变记录 falls through
		case ACTION.GET_ACCOUNT_CR:
		// 获取团队管理首页 falls through
		case ACTION.DASH_GET_TEAMUSER_LIST: {
			_state[action.node] = action.result;
			console.log(action)
			return state.merge(_state);
		}
		// 团队统计
		case ACTION.GET_TEAM_STATISTICS: {
			const summary = _.merge({}, action.result.summary, action.result.summaryExt);
			let chart = [];
			_.each(action.result.chart, (item) => {
				_.each(item.summary, (value, key) => {
					if(_.includes(['totalordernum', 'profit_loss'], key)){
						return;
					}
					let title;
					switch (key){
						case 'sum_deposit': title = '充值'; break;
						case 'sum_withdraw': title = '提款'; break;
						case 'sum_point': title = '返点'; break;
						case 'sum_bonus': title = '中奖'; break;
						case 'sum_activity': title = '活动'; break;
						case 'sum_wages': title = '代理工资'; break;
						case 'sum_prize': title = '投注'; break;
						case 'totalActivePeople': title = '活跃人数'; break;
					}
					if(!action.result.isContractUser && key == 'sum_wages'){
						return true;
					}
					chart.push({date: item.date, title, value});
				})
			})
			_state['statistics'] = {
				summary, chart,
				isContractUser: !!action.result.isContractUser
			};
			return state.merge(_state);
		}
		// 下级契约
		case ACTION.GET_TEAM_CONTRACT:{
			action.result.chlidren = _.chain(action.result.children || []).map(item => _.pick(item, ['userid', 'username'])).value();
			_state[action.node] = action.result;
			return state.merge(_state);
		}
		case ACTION.DESTROY_NODE:{
			_.each(action.nodes, node => {
				_state[node] = null;
			})
			return state.merge(_state);
		}
		// 注销用户
		case USER_ACTION.LOGOUT: {
			return Immutable.fromJS( _state );
		}

		default:
			return state;
	}
}
